import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'MyContestDraw',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            contestId: this.$route.params.contestId,
            isLoading: false,
            drawHistory:[],
            showDrawInfoPop:false,
            currentDrawInfo:null,
        }
    },
    created() {
        this.getDrawHistory()
    },
    methods: {
        async getDrawHistory() {
            try {
                this.drawHistory = await contestApi.playerDrawHistory(this.contestId);
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$toast.fail(error.message)
            }
        },
        async startDraw(){
            this.$toast.loading()
            try {
                this.currentDrawInfo = await contestApi.playerStartDraw(this.contestId,this.drawHistory[this.drawHistory.length-1].session);
                this.getDrawHistory()
                this.showDrawInfoPop = true
                this.$toast.success('抽签成功')

            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        toSubareaInfo(item){
            this.$router.push({path:'/my-contests/' + this.contestId + '/live/area',query:{
                    session:item.session,
                    currentAreaInfo:{
                        text:'第'+(item.subarea == null?'1':item.subarea)+'区',
                        value:item.subarea == null?'1':item.subarea
                    }
                }})
        }
    }
}
